import * as React from 'react';
import { dequal as deepEqual } from 'dequal';

type UseEffectParams = Parameters<typeof React.useEffect>;
type EffectCallback = UseEffectParams[0];
type DependencyList = UseEffectParams[1];

type UseEffectReturn = ReturnType<typeof React.useEffect>;

function useDeepCompareMemoize(value: DependencyList) {
  const ref = React.useRef<DependencyList>();
  const signalRef = React.useRef<number>(0);

  if (!deepEqual(value, ref.current)) {
    ref.current = value;
    signalRef.current += 1;
  }

  return [signalRef.current];
}

export function useDeepCompareEffect(
  callback: EffectCallback,
  dependencies: DependencyList
): UseEffectReturn {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useEffect(callback, useDeepCompareMemoize(dependencies));
}

export function useDeepCompareLayoutEffect(
  callback: EffectCallback,
  dependencies: DependencyList
): UseEffectReturn {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useLayoutEffect(callback, useDeepCompareMemoize(dependencies));
}

export default useDeepCompareEffect;
